module.exports = __webpack_public_path__ + "static/media/customWebSystems.0b14890d.png";